/* These lines of code are defining constants in JavaScript using the `export const` syntax. Each
constant represents an action type that can be dispatched in a Redux application. */
export const ADD_PRODUCT_TO_CART_SUCCESS = 'ADD_PRODUCT_TO_CART_SUCCESS';
export const ADD_PRODUCT_TO_CART_REQUEST = 'ADD_PRODUCT_TO_CART_REQUEST';
export const GET_CART_PRODUCTS = 'GET_CART_PRODUCTS';
export const GET_CART_PRODUCTS_REQUEST = 'GET_CART_PRODUCTS_REQUEST';
export const SET_SELECTED_CATEGORY_ID = 'SET_SELECTED_CATEGORY_ID';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const CLEAR_CART_DATA = 'CLEAR_CART_DATA';
